@import './pk-chip.variables';

:host {
  @apply inline-block;
}

.pk-chip--button {
  @apply relative box-border flex items-center;
  @apply bg-transparent px-[var(--chip--paddingX)] py-[calc(var(--chip--paddingY)_-_1px)] no-underline outline-none;
  @apply rounded-full border-[1px] border-solid border-transparent outline-none;
  @apply transition duration-250 hover:cursor-pointer;
  // Focus state
  @apply focus-visible:enabled:focus-outline;

  &::before {
    @apply absolute left-0 top-0 h-full w-full bg-[var(--chip--bg-color)] content-[''];
    @apply rounded-full border-none transition duration-250;
  }
}

.pk-chip--button__stroke {
  // Hover and Active states
  @apply hover:before:opacity-40 active:before:bg-ui-01;

  &.selected {
    @apply border-interaction;
  }

  &.selected span[part='text-primary'],
  &.selected span[part='icon'] {
    @apply font-semibold text-interaction;
  }
}

.pk-chip--button__filled {
  --chip--bg-color: theme('colors.transparent');
  // Active state
  @apply active:before:bg-ui-01;
}

.pk-chip--button__blur {
  --chip--bg-color: rgba(255, 255, 255, 0.2);
  // Hover and Active states
  @apply hover:before:bg-[rgba(255,_255,_255,_0.05)] active:before:bg-[rgba(255,_255,_255,_0.4)];
  @apply before:backdrop-blur;
}

.pk-chip--button__stroke,
.pk-chip--button__filled,
.pk-chip--button__blur {
  &:hover:not(.selected) {
    span[part='text-primary'],
    span[part='icon'] {
      @apply text-interaction;
    }

    span[part='text-secondary'] {
      @apply text-text-01;
    }
  }
}

.pk-chip--button__filled,
.pk-chip--button__blur {
  &.selected {
    --chip--bg-color: theme('colors.interaction');
    @apply before:bg-interaction;
  }

  &.selected span {
    @apply text-interactionCompl;
  }

  &.selected span[part='text-primary'],
  &.selected span[part='icon'] {
    @apply font-semibold;
  }
}

.fixed {
  @apply w-[var(--pk-chip--width)];

  span[part^='text'] {
    @apply line-clamp-1 overflow-hidden;

    ::slotted(*) {
      @apply line-clamp-1 overflow-hidden;
    }
  }
}

div[part='text'] {
  text-align: var(--pk-chip--text-align);
}

span {
  @apply transition duration-250;

  ::slotted([slot^='text']) {
    @apply font-regular leading-m;
  }

  ::slotted([slot='text-primary']) {
    @apply text-m;
  }

  ::slotted([slot='text-secondary']) {
    @apply text-s;
  }

  .icon-close,
  ::slotted(pk-icon) {
    @apply ml-xs [--icon--color:inherit];
  }
}
